export default "/institutions/nomad.svg";